import "./primaryButton.scss";

export function PrimaryButton(props: {text: string | undefined, function: Function, negative:boolean }) {
  let negative = props.negative
  return (
    <button className={negative?("negative"):("gno-primary-button")} onClick={() => props.function()}>{props.text}</button>
  );
}
